import React, { useState } from "react";
import styles from "./DestinationCard.module.scss";
import { Heart, ArrowRight } from "lucide-react";
import { Destination } from "../types/destination";
import { Modal } from "./Modal";
import DestinationExpanded from "./DestinationExpanded";

interface DestinationCardProps {
    destination: Destination;
    size?: "large" | "medium" | "small";
    saved?: boolean;
    onToggleSave?: (slug: string) => void;
}

const fmtUSD = (p: number) => `$${Number(p).toLocaleString("en-US")}`;

export const DestinationCard: React.FC<DestinationCardProps> = ({
    destination,
    size = "large",
    saved = false,
    onToggleSave,
}) => {
    const [open, setOpen] = useState<boolean>(false);
    const sizeClass =
        size === "medium" ? styles.cardMedium : size === "small" ? styles.cardSmall : "";

    return (
        <>
            <div className={`${styles.card} ${sizeClass}`}>
                <div
                    className={styles.cardInner}
                    role="button"
                    tabIndex={0}
                    onClick={() => setOpen(true)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                            e.preventDefault();
                            setOpen(true);
                        }
                    }}
                >
                    <img
                        src={destination.image}
                        alt={destination.name}
                        loading="lazy"
                        className={styles.photo}
                    />
                    <div className={styles.gradient} />
                    {destination.match && (
                        <span className={styles.match}>{destination.match}% match</span>
                    )}
                    <button
                        className={`${styles.heart} ${saved ? styles.heartSaved : ""}`}
                        onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            onToggleSave?.(destination.slug);
                        }}
                        type="button"
                        aria-label="Save"
                    >
                        <Heart size={16} fill={saved ? "currentColor" : "none"} />
                    </button>
                    <div className={styles.info}>
                        <h3 className={styles.dest}>{destination.name}</h3>
                        <p className={styles.tag}>{destination.tagline}</p>
                        <p className={styles.price}>From {fmtUSD(destination.price)}</p>
                    </div>
                    <span className={styles.cta}>
                        <span className={styles.ctaText}>Plan Trip</span>
                        <ArrowRight size={14} strokeWidth={2.5} />
                    </span>
                </div>
            </div>
            <Modal isOpen={open} onClose={() => setOpen(false)} size="page">
                <DestinationExpanded slug={destination?.slug} inModal />
            </Modal>
        </>
    );
};